/* Shared by the local prototype and the Shopify hero section. */
class ChikasCarousel extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    const signal = this.controller.signal;
    this.slides = [...this.querySelectorAll('[data-slide]')];
    if (!this.slides.length) return;
    this.index = 0;
    this.delay = Math.max(3000, Number(this.dataset.interval) || 5000);
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.paused = this.reduced.matches;
    this.hovered = false;
    this.focused = false;
    this.visible = true;
    this.setAttribute('role', 'region');
    this.setAttribute('aria-roledescription', 'carrusel');
    this.setAttribute('aria-label', 'Campañas CHIKAS');
    this.controls = document.createElement('div');
    this.controls.className = 'carousel-controls';
    this.controls.innerHTML = `<button type="button" data-prev aria-label="Imagen anterior">←</button><span data-count aria-live="off"></span><div class="carousel-dots">${this.slides.map((_,i)=>`<button type="button" data-dot="${i}" aria-label="Ver imagen ${i+1}"></button>`).join('')}</div><button type="button" data-next aria-label="Imagen siguiente">→</button><button type="button" data-pause aria-label="Pausar carrusel">Ⅱ</button>`;
    this.append(this.controls);
    this.controls.hidden = this.slides.length < 2;
    this.controls.addEventListener('click', e => {
      const b = e.target.closest('button');
      if (!b) return;
      if (b.hasAttribute('data-pause')) { this.paused = !this.paused; this.updatePause(); this.schedule(); }
      else if (b.hasAttribute('data-dot')) this.show(Number(b.dataset.dot));
      else this.show(this.index + (b.hasAttribute('data-next') ? 1 : -1));
    }, {signal});
    this.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse'){this.hovered=true;this.schedule();} }, {signal});
    this.addEventListener('pointerleave', () => {this.hovered=false;this.schedule();}, {signal});
    this.addEventListener('focusin', () => {this.focused=true;this.schedule();}, {signal});
    this.addEventListener('focusout', e => {if(!this.contains(e.relatedTarget)){this.focused=false;this.schedule();}}, {signal});
    this.addEventListener('keydown', e => {
      if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.show(this.index+(e.key==='ArrowRight'?1:-1));}
    }, {signal});
    this.addEventListener('touchstart', e => {this.touch=[e.touches[0].clientX,e.touches[0].clientY];}, {passive:true,signal});
    this.addEventListener('touchend', e => {
      if(!this.touch)return;
      const dx=e.changedTouches[0].clientX-this.touch[0],dy=e.changedTouches[0].clientY-this.touch[1];
      if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.show(this.index+(dx<0?1:-1));
      this.touch=null;
    }, {passive:true,signal});
    document.addEventListener('visibilitychange',()=>this.schedule(),{signal});
    this.reduced.addEventListener('change',()=>{this.paused=this.reduced.matches;this.updatePause();this.schedule();},{signal});
    document.addEventListener('shopify:block:select', e=>{
      const i=this.slides.findIndex(s=>s===e.target||s.contains(e.target));
      if(i>=0){this.paused=true;this.updatePause();this.show(i);}
    },{signal});
    this.observer=new IntersectionObserver(([entry])=>{this.visible=entry.isIntersecting;this.schedule();});
    this.observer.observe(this);
    this.show(0);
    this.classList.add('is-ready');
    this.updatePause();
  }
  updatePause(){const b=this.controls.querySelector('[data-pause]');b.textContent=this.paused?'▶':'Ⅱ';b.setAttribute('aria-label',this.paused?'Reanudar carrusel':'Pausar carrusel');}
  show(index){
    this.index=(index+this.slides.length)%this.slides.length;
    this.slides.forEach((s,i)=>{s.classList.toggle('is-active',i===this.index);s.setAttribute('aria-hidden',String(i!==this.index));});
    this.controls.querySelector('[data-count]').textContent=`${String(this.index+1).padStart(2,'0')} / ${String(this.slides.length).padStart(2,'0')}`;
    this.controls.querySelectorAll('[data-dot]').forEach((b,i)=>b.setAttribute('aria-current',String(i===this.index)));
    this.schedule();
  }
  schedule(){clearTimeout(this.timer);if(!this.paused&&!this.hovered&&!this.focused&&this.visible&&!document.hidden&&this.slides.length>1)this.timer=setTimeout(()=>this.show(this.index+1),this.delay);}
  disconnectedCallback(){clearTimeout(this.timer);this.observer?.disconnect();this.controller?.abort();this.controls?.remove();this.controller=null;}
}
if(!customElements.get('chikas-carousel'))customElements.define('chikas-carousel',ChikasCarousel);
